/**
 * Upscales an ImageData object to the target dimensions using smoothing.
 * @param {ImageData} imageData - The source image data.
 * @param {number} targetWidth - The desired width.
 * @param {number} targetHeight - The desired height.
 * @returns {ImageData} - The upscaled ImageData.
 */
export function upscaleImageData(imageData, targetWidth, targetHeight) {
  const tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = imageData.width;
  tmpCanvas.height = imageData.height;
  const tmpCtx = tmpCanvas.getContext('2d');
  tmpCtx.putImageData(imageData, 0, 0);

  const targetCanvas = document.createElement('canvas');
  targetCanvas.width = targetWidth;
  targetCanvas.height = targetHeight;
  const targetCtx = targetCanvas.getContext('2d');
  targetCtx.imageSmoothingEnabled = true;
  targetCtx.imageSmoothingQuality = 'high';
  targetCtx.drawImage(tmpCanvas, 0, 0, targetWidth, targetHeight);
  return targetCtx.getImageData(0, 0, targetWidth, targetHeight);
}

/**
 * Preprocesses a video frame by drawing it on an offscreen canvas and applying a slight blur.
 * @param {HTMLVideoElement} video - The video element.
 * @param {number} width - The width to use.
 * @param {number} height - The height to use.
 * @returns {ImageData} - The preprocessed frame as ImageData.
 */
export function preProcessFrame(video, width, height) {
  const offscreenCanvas = document.createElement('canvas');
  offscreenCanvas.width = width;
  offscreenCanvas.height = height;
  const offscreenCtx = offscreenCanvas.getContext('2d');
  offscreenCtx.clearRect(0, 0, width, height);
  offscreenCtx.drawImage(video, 0, 0, width, height);
  // Apply a slight blur filter.
  offscreenCtx.filter = 'blur(2px)';
  offscreenCtx.drawImage(offscreenCanvas, 0, 0);
  return offscreenCtx.getImageData(0, 0, width, height);
}
